import { createSelector } from 'reselect';

const routingSelector = state => state.routing;
const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;
const uiStateSelector = state => state.ui;
const adsStateSelector = state => state.ads;

export default createSelector(
	[routingSelector, topifyPresetsSelector, userStateSelector, uiStateSelector, adsStateSelector],
	(routing, topifyPresets, ustate, ui, ads) => {
		return {
			topifyPresets: topifyPresets,
			ads: ads,
			ustate: ustate,
			routing: routing,
			overlayElements: {
				sidebarOpened: ui.sidebarOpened,
				searchBarOpened: ui.searchBarOpened,
				headerOverflowOpened: ui.headerOverflowOpened,
				loginModalOpened: ui.loginModalOpened,
				confirmModalOpened: ui.confirmModalOpened,
				globalLoading: ui.globalLoading,
				replyModalOpened: ui.replyModal.opened,
				userModalOpened: ui.userModal.opened,
				shareModalOpened: ui.shareModal.opened,
				announcementsOpen: ui.announcementsOpen
			}
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/adSelector.js